var map = {
	"./dev.env": "5bex",
	"./local.env": "Zev4",
	"./prod.env": "tvPj",
	"./qa.env": "Ndir",
	"./refactory.env": "NJsu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2XW+";


//////////////////
// WEBPACK FOOTER
// ./src/config ^\.\/.*\.env$
// module id = 2XW+
// module chunks = 1